export default {
  tableData: [
    {
      data: 'dsadsa',
      dia: 'dsasda',
      qtdProgIn: '11',
      qtdConcIn: '11',
      atendConclIn: '00.55',
      dentroPrazoIn: '12.55',
      oeeEntrada: '100',
      qtdProgOut: '123123',
      qtdConcOut: '123',
      atendConclOut: '33.85',
      dentroPrazoOut: '213',
      ooeSaida: '88.88',
      ooeGlobal: '67.8',
      ave: '324234',
      avi: '324234',
    },
  ],
  headers: [
    {
      value: 'data',
      i18n: 'Data',
      text: '',
    },
    {
      value: 'dia',
      i18n: 'Dia',
      text: '',
    },
    {
      value: 'qtdProgIn',
      i18n: 'Qtd Prog (In)',
      text: '',
    },
    {
      value: 'qtdConcIn',
      i18n: 'Qtd Conc. (In)',
      text: '',
    },
    {
      value: 'atendConclIn',
      i18n: '% Atend. Concl. (In)',
      text: '',
    },
    {
      value: 'dentroPrazoIn',
      i18n: '% Dentro Prazo (In)',
      text: '',
    },
    {
      value: 'oeeEntrada',
      i18n: 'OOE Entrada',
      text: '',
    },
    {
      value: 'qtdProgOut',
      i18n: 'Qtd Prog (Out)',
      text: '',
    },
    {
      value: 'qtdConcOut',
      i18n: 'Qtd Conc. (Out)',
      text: '',
    },
    {
      value: 'atendConclOut',
      i18n: '% Atend. Concl. (Out)',
      text: '',
    },
    {
      value: 'dentroPrazoOut',
      i18n: 'OOE Saída',
      text: '',
    },
    {
      value: 'ooeSaida',
      i18n: 'OEE Saída',
      text: '',
    },
    {
      value: 'ooeGlobal',
      i18n: 'OEE Global',
      text: '',
    },
    {
      value: 'ave',
      i18n: 'AVE',
      text: '',
    },
    {
      value: 'avi',
      i18n: 'AVI',
      text: '',
    },
  ],
  camposDataTablePorcentagemProgressBar: [
    'atendConclIn',
    'dentroPrazoIn',
    'oeeEntrada',
    'atendConclOut',
    'dentroPrazoOut',
    'ooeSaida',
    'ooeGlobal',
  ],
  quantidadeInventariadaCliente: [],
  acuraciaPorUnidade: {},
  acuraciaPorCliente: {},
  acuraciaMensal: {},
  acuraciaQuantidadeItemCliente: {},
  acuraciaQuantidadeInventariadaProduto: {},
  informacoesEstoque: [],
};
